import {
  INCREASE_LOADING,
  DECREASE_LOADING,
  APP_ERROR,
} from "../../app/actions";
import fetch from "isomorphic-fetch";
import { hashFromObj } from "./hash";

export const postRequest = async (url, data, requestOptions) => {
  let rs;
  let body;

  try {
    rs = await fetch(`${url}`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: requestOptions.headers,
    });
  } catch (e) {
    throw e;
  }

  const status = rs.status;
  if (status >= 200 && status <= 299) {
    body = await rs.json();
  }

  return { status, body };
};

export const patchRequest = async (url, data, requestOptions) => {
  let rs;
  let body;

  try {
    rs = await fetch(`${url}`, {
      method: "PATCH",
      body: JSON.stringify(data),
      headers: requestOptions.headers,
    });
  } catch (e) {
    throw e;
  }

  const status = rs.status;
  if (status >= 400 && status <= 422) {
    body = await rs.json();
  }

  return { status, body };
};

export const postFormDataRequest = async (url, data) => {
  let rs;
  let body;

  try {
    rs = await fetch(`${url}`, {
      body: data,
      method: "POST",
    });
  } catch (e) {
    throw e;
  }

  const status = rs.status;
  if (status >= 200 && status <= 299) {
    body = await rs.json();
  }

  return { status, body };
};

export const deleteRequest = async (url, requestOptions) => {
  let rs;

  try {
    rs = await fetch(`${url}`, {
      method: "DELETE",
      headers: requestOptions.headers,
    });
  } catch (e) {
    throw e;
  }

  const status = rs.status;

  return { status };
};

export const getRequest = async (url, requestOptions) => {
  let rs;
  let body;

  try {
    rs = await fetch(`${url}`, {
      method: "GET",
      headers: requestOptions.headers,
    });
  } catch (e) {
    throw e;
  }

  const status = rs.status;
  if (status >= 200 && status <= 299) {
    body = await rs.json();
  }

  return { status, body };
};

let requestsPending = [];

export const handleError = (dispatch, getState, action, error) => {
  const msg = getState().intl.messages[getState().intl.get("currentLocale")];

  requestsPending = [];
  if (action) {
    dispatch({ type: action + "_FINALLY" });
  }
  dispatch({ type: DECREASE_LOADING });

  console.error(error);

  if (error instanceof TypeError) {
    dispatch({ type: APP_ERROR, payload: msg["app.errors.networkError"] });
  } else {
    dispatch({ type: APP_ERROR, payload: msg["app.errors.fatalError"] });
  }
};

const startRequest = (dispatch, getState, action) => {
  const msg = getState().intl.messages[getState().intl.get("currentLocale")];

  dispatch({ type: INCREASE_LOADING });
  dispatch({ type: action });

  return msg;
};

export const apiRequest = async (
  dispatch,
  getState,
  { apiHost, validate },
  action,
  validateFunc,
  apiCall,
  data,
  requestData,
  apiErrorsCallback
) => {
  const hash = hashFromObj({ action, data });
  if (action.startsWith("GET_")) {
    if (requestsPending[hash]) {
      return;
    }
  }
  requestsPending[hash] = hash;

  const msg = startRequest(dispatch, getState, action);

  if (validateFunc !== null) {
    const errors = validateFunc(validate, msg, data);
    if (errors) {
      dispatch({
        type: action + "_ERROR",
        payload: { errors: errors, data: data },
      });
      dispatch({ type: DECREASE_LOADING });
      requestsPending[hash] = null;
      return;
    }
  }

  let requestOptions = [];
  if (requestData && requestData.headers) {
    requestOptions["headers"] = requestData.headers || {};
  }

  const state = getState();
  const token = state.auth && state.auth.token && state.auth.token.token;

  if (requestData && requestData.authorized) {
    requestOptions["headers"]["Authorization"] = "Bearer " + token;
  }

  let { status, body } = await apiCall(apiHost, data, requestOptions);

  //if(status >= 500) {
  //dispatch({ type: APP_ERROR, payload: msg['app.errors.fatalError'] });
  //}
  if (status > 299) {
    dispatch({
      type: action + "_ERROR",
      payload: { errors: apiErrorsCallback(body), data: data },
    });
    dispatch({ type: DECREASE_LOADING });
    requestsPending[hash] = null;
    return { status, body };
  } else {
    dispatch({
      type: action + "_SUCCESS",
      payload: { body: body, data: data },
    });
    dispatch({ type: DECREASE_LOADING });
    requestsPending[hash] = null;
    return { status, body };
  }
};



/** WEBPACK FOOTER **
 ** ./src/common/lib/utils/request.js
 **/